// How the calendar's reminders are shown in the notification centre.

import type { NotificationPresenter } from "@/notifications/client";
import { REMINDER_NOTIFICATIONS } from "@/planning/model/wire.js";
import { isoDayInZone } from "@/platform/kit";
import { fmtCivilDay, fmtTime } from "@/platform/client";
import { IconCalendar } from "@/platform/ui";

/** The occurrence a reminder is for. The server sends the raw start, and the
 *  client formats it in the viewer's zone. */
function when(meta: { eventStart: string; allDay: boolean }, tz: string): string {
  // Zone-less: the civil date verbatim, never shifted through a zone.
  if (meta.allDay) return fmtCivilDay(meta.eventStart.slice(0, 10), { year: false });
  const d = new Date(meta.eventStart);
  return `${fmtCivilDay(isoDayInZone(d, tz), { year: false })} ${fmtTime(d, tz)}`;
}

export const calendarNotifications: NotificationPresenter = {
  source: REMINDER_NOTIFICATIONS,
  icon: (_, size) => <IconCalendar size={size} />,
  detail: (n, tz) =>
    n.meta && typeof n.meta.eventStart === "string"
      ? when({ eventStart: n.meta.eventStart, allDay: n.meta.allDay === true }, tz)
      : null,
};
